// extracted by mini-css-extract-plugin
export default {"form-button":"FormButton_form-button__+LD9Z","dark":"FormButton_dark__gkNBc","bright":"FormButton_bright__XQJZg","dis":"FormButton_dis__aYGKa"};